import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./pc_style.less?vue&type=style&index=0&id=2df83f92&lang=less&scoped=true"
import "./mobile_style.less?vue&type=style&index=1&id=2df83f92&lang=less&scoped=true"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2df83f92"]])

export default __exports__